<template>
<div>
    <div class="row">
      <div class="col-md-12">
          <h3>Usage</h3>

          <div class="row mt20">
              <div class="col-md-12">
                  <h6>Making your First API Call</h6>
                  <div>TODO curl example, verbs</div>
              </div>
          </div>

          <div class="row mt20">
              <div class="col-md-12">
                  <h6>Appropriate Usage</h6>
                  <div>TODO rate limits</div>
              </div>
          </div>
      </div>
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "Usage",
})
</script>